import { FC, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import useDataInitializer from "../../hooks/useDataInitializer";
import { useDebounce } from "../../hooks/useDebounce";
import useListFilters from "../../hooks/useListFilters";
import useI18n from "../../hooks/useTranslations";
import { useUsersApi } from "../../http/users/api";
import { User } from "../../http/users/types";
import { PaginationQuery } from "../../types";
import Header from "../ui/Header";
import Table from "../ui/Table";

const Users: FC = () => {
  const i18n = useI18n();
  const usersApi = useUsersApi();
  const filters = useListFilters({ isSearchable: true });
  const debouncedValue = useDebounce(filters.state.q);
  const aborter = useRef(new AbortController());
  const navigate = useNavigate();
  // const dispatch = useContext(NotificationDispatch);
  // const [itemToDelete, setItemToDelete] = useState<User>();

  const query: PaginationQuery = {
    ...filters.state,
    q: debouncedValue,
  };

  const navToEdit = (item: User) => {
    navigate(`/admin/users/${item.id}`);
  };

  const result = usersApi.useAdminUsers(query, aborter.current.signal);
  const [data, error, isInitialized] = useDataInitializer(result.data, result.error);

  if (!data && !error && !isInitialized) {
    return;
  }

  return (
    <>
      <Header title={i18n.translation.users.plural} />
      <Table<User>
        filters={filters}
        searchOptions={{
          placeholder: i18n.translation.users.search,
          onChange: () => {
            aborter.current.abort();
            aborter.current = new AbortController();
          },
        }}
        // buttons={{
        //   main: <Button buttonProps={{ onClick: () => navigate("/admin/users/new") }} glyph={SvgAdd}></Button>,
        // }}
        head={
          <tr>
            <th align="left">{i18n.translation.common.name}</th>
            <th align="left">{i18n.translation.common.email}</th>
            <th></th>
          </tr>
        }
        renderRow={(item) => (
          <>
            <td>
              <Link to={`/admin/users/${item.id}`}>
                {item.firstName} {item.lastName}
              </Link>
            </td>
            <td>{item.email}</td>
          </>
        )}
        rowActions={[
          { getTitle: () => i18n.translation.common.edit, onClick: navToEdit },
          // { getTitle: () => i18n.translation.common.delete, onClick: setItemToDelete },
        ]}
        error={!!error}
        items={data?.items}
        total={data?.total}
      />
      {/* <ModalDialog
        isOpen={!!itemToDelete}
        onClose={() => setItemToDelete(undefined)}
        title={i18n.translation.common.delete}
        actions={[
          { title: i18n.translation.common.cancel, type: "secondary", onClick: () => setItemToDelete(undefined) },
          {
            title: i18n.translation.common.yes,
            type: "primary",
            onClick: () => {
              itemToDelete &&
                usersApi
                  .deleteAdminUser(itemToDelete.id)
                  .then(() => setItemToDelete(undefined))
                  .catch((err) => dispatch(showErrorNotification(i18n, err)));
            },
          },
        ]}
      >
        {i18n.translation.users.questions.delete}
      </ModalDialog> */}
    </>
  );
};

export default Users;
